import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, ChevronRight } from 'lucide-react';

const HIDDEN_PREFIXES = [
  '/login', '/register', '/forgot-password', '/reset-password', '/email-confirmed', '/welcome',
  '/account', '/orders', '/order', '/book', '/admin', '/property', '/listing-editor', '/invoice', '/services/digital-persona-development/order',
];

export const MobileBookBar = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p))) return null;

  return (
    <>
      <div className="md:hidden h-[calc(68px+env(safe-area-inset-bottom,0px))]" aria-hidden="true" />
      <div
        className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#050816]/95 backdrop-blur-md border-t border-white/10 px-4 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom,0px))] animate-in slide-in-from-bottom-4 fade-in duration-500"
        data-testid="mobile-book-bar"
      >
        <div className="flex items-center gap-3">
          <Link
            to="/book"
            data-testid="mobile-book-bar-book-btn"
            className="flex-1 inline-flex items-center justify-center gap-1.5 h-12 rounded-lg bg-[#C6A14A] text-[#050816] font-semibold tracking-wide active:scale-[0.98] transition-transform"
          >
            Book a Shoot
            <ChevronRight className="w-4 h-4" />
          </Link>
          <a
            href="tel:+19285306604"
            aria-label="Call RC Studios at (928) 530-6604"
            data-testid="mobile-book-bar-call-btn"
            className="shrink-0 inline-flex items-center justify-center h-12 w-12 rounded-lg border border-[#C6A14A]/50 text-[#C6A14A] active:scale-95 transition-transform"
          >
            <Phone className="w-5 h-5" />
          </a>
        </div>
      </div>
    </>
  );
};
